<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'国外市场'}]"/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item v-if="showArea" label="　创建人名称">
							    <el-input v-model="formInline.userName" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="创建月份">
							    <el-date-picker
							            :clearable="false"
							            v-model="formInline.createdDateLike"
							            type="month"
										style="width: 100%;"
							            value-format="yyyy-MM"
							            placeholder="--月份--">
							    </el-date-picker>
							</el-form-item>
							<el-form-item label="审核状态">
							    <el-select v-model="formInline.isDel" clearable placeholder="请选择">
							        <el-option
							                v-for="item in shStatus"
							                :key="item.value"
							                :label="item.label"
							                :value="item.value">
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item>
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
								<el-button v-auth="'xzycan'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createdict">新增预测</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
							max-height="430"
                            style="width: 100%">
                        <el-table-column
                            type="selection"
                            width="40">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="userName"
                                label="创建人名称"
								width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="createdDate"
                                label="创建时间"
								width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="预测状态"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.status"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                :show-overflow-tooltip="true"
                                label="备注">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.remark}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="timeFirst"
                                label="预测开始时间"
                                :show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="timeLast"
                                label="预测结束时间"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="mark"
                                label="备注"
								:show-overflow-tooltip="true"
                                v-if="showmark">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.mark}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="240">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
									<el-button v-if="scope.row.status != 1"
									           @click="showRow(scope.row.id, scope.row.status)"
									           type="text"
									           size="small" class="h-tableLink h-btn">查看
									</el-button>
									<el-button
									        v-if="_user.usercode == scope.row.cucode && (scope.row.status == 1 || scope.row.status == 4)"
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="editData(scope.row.id, scope.row.status)">
									    编辑
									</el-button>
									<el-button
									        size="small" class="h-tableLink h-btn" v-if="scope.row.instId"
									        @click="genzongLiuch(scope.row)">
									    跟踪
									</el-button>
									<el-button
									        v-if="(scope.row.status == 1 || scope.row.status == 4) && _user.usercode == scope.row.cucode"
									        @click.native.prevent="deleteId(scope.row)"
									        type="text" size="small" class="h-tableLink h-btn">删除
									</el-button>
								</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 Time">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>新建外销预测信息</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="预测开始时间" class="h-elformWrap-2">
                                <el-date-picker
                                        v-model="f.timeFirst"
                                        type="date"
                                        class="h-tableInput"
                                        value-format="yyyy-MM-dd"
                                        placeholder="--请选择日期--"
                                        :picker-options="pickerOptions1"
                                        @change="dateChange1">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="预测结束时间" class="h-elformWrap-2">
                                <el-date-picker
                                        v-model="f.timeLast"
                                        type="date"
                                        class="h-tableInput"
                                        value-format="yyyy-MM-dd"
                                        placeholder="--请选择日期--"
                                        :picker-options="pickerOptions2"
                                        @change="dateChange2">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" class="h-elformWrap-2">
                                <el-input v-model="f.remark" placeholder="请输入..." style="width:398px"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveTo">确定</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleFilter"/>
                </div>
            </div>
            <!--<div class="left">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportExcel">批量导出
                </el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                           @click="daoru">批量导入
                </el-button>
            </div>
            <el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
                <div class="h-dialogImg">
                    <div style="display:flex;align-items:center;">
                        <img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
                        <div>
                            <p class="piliang1">批量导入</p>
                            <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
                        </div>
                    </div>

                    <div class="piliangBox">
                        <div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
                                               style="width: 40px;height: 39px;"></div>
                        <div class="imgs">批量导入模版文件.xlsx</div>
                        <div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
                    </div>
                    <div style="width:100%;">
                        <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                        >
                            <div style="width:100%;">+ 上传文件</div>
                        </el-upload>
                    </div>
                    <div style="display:flex;justify-content:center;margin-top:30px;">
                        <el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
                            取消
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ2" style="margin-left:40px;"
                                   @click="dialogFormVisible2 = false">提交
                        </el-button>
                    </div>
                </div>
            </el-dialog>-->
        </div>
		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<style>
	.Time .h-formbLine .h-elformWrap-2{
	    width: 50%;
	}
    .Time .el-form-item__content .el-input__inner{
        padding-right: 47px;
    }
    .Time  .h-elformWrap-2 .el-form-item__label{
        width: 45%;
        vertical-align:bottom;
    }
    .Time .h-elformWrap-2 .el-form-item__content{
        width: 55%;
    }
    /* .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    } */

    /* .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;

        margin-bottom: 20px;
    }

    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;

    } */
</style>

<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                shStatus: [{
                    value: '2',
                    label: '待审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }, {
                    value: '4',
                    label: '审核驳回'
                }],
                // dialogFormVisible2: false,
                mon: '',
                day1: "",
                day2: "",
                formInline: {
                    // createdDateLike: this.getyyyyMMdd(),
                    createdDateLike: '',
                    isDel: '',
                    userName: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions2: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                userRole: [],
                tableData: [],
                showArea: false,
                showEdit: false,
                dialogFormVisible: false,
                chakan: false,
                shanchu: false,
                showmark: false,
                showhistory:false,
                instid: '',
                a: 10,
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f: {
                    timeFirst: '',
                    timeLast: '',
                    remark: ''
                }
            }
        },
        mounted() {
        },
        created() {
            this.query();
        },
        activated(){
            this.handleFilter();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
            genzongLiuch(v){
                this.instid = v.instId;
                this.showhistory = true;
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
            editData(v,s) {
                this.$router.push({path: "/yuce/export_list", query: {bid: v, bstatus: s}});
            },
            resetData() {
                this.formInline.userName = '';
                this.formInline.createdDateLike = '';
                this.formInline.isDel = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            dateChange1(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.timeLast = "";
                    this.day2 = 0;
                }
            },
            dateChange2(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.timeLast = "";
                    this.day2 = 0;
                }
            },
            getyyyyMMdd() {
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1,].join('-');
            },
            query() {
                ss.wxhuizong.showPage(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        var v = item.timeLast;
                        v = v.replace(/-/g, '/')
                        var date = new Date(v);
                        var da = date.getTime();
                        da = da - 21 * 24 * 60 * 60 * 1000;
                        var today = new Date();
                        //若在今天以前
                        if (da < today) {
                            item.mark = 1;
                        } else {
                            item.mark = 2;
                        }
                    })
                })
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_admin" || item.id == "swyl_waixiaogly") {
                        this.a = 0;
                    }
                })
                if (this.a == 0) {
                    this.showArea = true;

                }
                if (this.a != 0) {
                    this.showArea = false;
                }
            },
            handleFilter() {
                ss.wxhuizong.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.mon = this.formInline.createdDateLike;
                    this.tableData.forEach((item, index) => {
                        var v = item.timeLast;
                        v = v.replace(/-/g, '/')
                        var date = new Date(v);
                        var da = date.getTime();
                        da = da - 21 * 24 * 60 * 60 * 1000;
                        var today = Date.now();
                        //若在今天以前
                        if (da < today) {
                            item.mark = 1;
                        } else {
                            item.mark = 2;
                        }
                    })
                })
            },
            createdict() {
                this.dialogFormVisible = true;
                this.f = {};
            },
            showRow(id, status) {
                this.$router.push({path: "/yuce/wxxiangqing", query: {id: id, status: status}})
            },
            saveTo() {
                if (this.f.timeFirst == null || this.f.timeLast == null) {
                    this.$msg.msge("请选择时间!");
                    return;
                }
                this.dialogFormVisible = false;
                ss.wxhuizong.saveTo(this.f).then(rd => {
                    this.$msg.msgs(rd.obj.xinxi);
                    this.editData(rd.obj.entity.id);
                })
            },
            deleteId(row) {
                this.$msg.confirm("确认删除?", () => {
                    ss.wxhuizong.deleteId(row.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    })
                })
            },
        }
    }
</script>